<template>
<div>
  <section class="padding"> 

<div @click.self="closeModal"  class="modal-bg">
<div class="modal">
     
      <div class="footer">
           <div class="flex">
<div class="container1">
<h1>Become a teacher <br> and work with us!</h1>
<img src="../../assets/underline3.png" alt="">
<h4>Li’lyogisbysabrina@gmail.com <br> +91 99999 99999</h4>
<div class="icons">
<img src="../../assets/Socialicon1.png" alt="">
<img src="../../assets/Socialicon2.png" alt="">
<img src="../../assets/Socialicon3.png" alt="">
<img src="../../assets/Socialicon4.png" alt="">
</div>
</div>


<!-- <div class="modal-bg container3">
    <div class="modal">
        <h2>Quick Links</h2>
    <h4 class="child">Home</h4>
    <h4 class="child">Our Programs</h4>
    <h4 class="child">Become a teacher</h4>
    <button>Register</button>
    </div>
</div> -->


<div class="container3">

<div class="wrapper">
    <div class="input-data">
        <input type="text" required>
        <div class="underline"></div>
        <label >Full Name</label>
    </div>
</div>
<div class="wrapper">
    <div class="input-data">
        <input type="text" required>
        <div class="underline"></div>
        <label >Phone</label>
    </div>
</div>
<div class="wrapper">
    <div class="input-data">
        <input type="text" required>
        <div class="underline"></div>
        <label >E-mail</label>
    </div>
</div>
<div class="wrapper">
    <div class="input-data">
        <input type="text" required>
        <div class="underline"></div>
        <label >Any other yoga qualification? (Y/N)</label>
    </div>
</div>
<div class="wrapper">
    <div class="input-data">
        <input type="text" required>
        <div class="underline"></div>
        <label >City</label>
    </div>
</div>




     <img @click="closeModal"  class="modal-close" src="../../assets/close_icon.png" alt="">
    <!-- <span @click="closeModal"  class="modal-close">X</span> -->
    <button   >Register</button>
</div>

</div>
</div>
      </div>


      </div>
  </section>
  </div>
</template>

<script>
export default {

props:["modalbg"],

methods:{
    closeModal(){
        this.$emit("close")
    }
}

// data(){
//     return{
//         modalbg2:true
//     }
// },
}
</script>

<style scoped>
.wrapper{
  width: 380px;
  background: #60993E;
  padding: 20px;
  /* box-shadow: 0px 0px 10px rgba(0,0,0,0.1); */
}
.wrapper .input-data{
  height: 40px;
  width: 100%;
  position: relative;
}
.wrapper .input-data input{
  height: 100%;
  width: 100%;
  border: none;
  font-size: 17px;
  border-bottom: 2px solid #FFFFF2;
      outline: none;
      background-color: #60993E;
      color: #FFFFF2;
}
.input-data input:focus ~ label
{
  transform: translateY(-20px);
  font-size: 15px;
  color: #FFFFF2;
}
.input-data input:valid ~ label{
 transform: translateY(-20px);
  font-size: 15px;
  color: #FFFFF2;
}
.wrapper .input-data label{
  position: absolute;
  bottom: 10px;
  left: 0;
  color: #FFFFF2;
  pointer-events: none;
  transition: all 0.3s ease;
}
.input-data .underline{
  position: absolute;
  height: 2px;
  width: 100%;
  bottom: 0;
}
.input-data .underline:before{
  position: absolute;
  content: "";
  height: 100%;
  width: 100%;
  background: #FFFFF2;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease;
}
.input-data input:focus ~ .underline:before,
.input-data input:valid ~ .underline:before{
  transform: scaleX(1);
}

button:hover{
    background-color: #ca6500;
}
button{
    color: white;
    background-color: #FF8100;
    border: none;
    padding: 15px 30px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s ease-in;
        margin-top: 35px;
}
.modal-close{
    position: absolute;
    top: 20px;
    right: 20px;
    font-weight: bold;
    color: white;
    cursor: pointer;
}
.modal-bg{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    /* visibility: hidden;
    opacity: 0; */
    transition: visibility 0s opacity 0.5s;
    z-index: 2000;
}

/* .bg-active{
    visibility: visible;
    opacity: 1;
} */

.modal{
    position: relative;
    background-color: #60993E;
    width: 1340px;
    height: 589px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    border-radius: 20px;
    z-index: 10000;
}
.padding{
    margin-top: 150px;
}
.icons{
        display: flex;
    justify-content: space-between;
    width: 191px;
}

.container1{
        display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
        height: 433px;
}

.container3{
        display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 302px;
    align-items: center;
}

.child{
    color:  #D9DBE1;
}

.footer{
    width: 100%;
height: 406px;
/* background: #4BA3C3; */

}
.flex{
display: flex;
    width: 90%;
    margin: auto;
    align-items: center;
    justify-content: space-around;
    /* padding-top: 36px; */
flex-wrap: wrap;
}
h1{
     font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: white;
}
h4{
    color: white;
    font-weight: 500;
    line-height: 200%;
}
h2{
    font-weight: 600;
    color: white;
}

@media(max-width: 850px){
    .modal{
        height: 893px;
    }
}
@media(max-width: 940px){
    .modal{
              height: 1068px;
    transform: scale(0.7);
    }
    .flex{
            position: relative;
    top: -338px;
    height: 1014px;
    }
    .modal-close{
            top: 56px;
    right: 14px;
    
    }
    .container1{
        align-items: center;
    }
    h1{
        text-align: center;
    }
    .modal-bg{
        /* position: absolute;
    top: 12px; */
        height: 749px;
    overflow-y: auto;
    }
    .modal-bg::-webkit-scrollbar { 
    display: none;
     -ms-overflow-style: none; 
    scrollbar-width: none; 
}
}

</style>